import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "src/app/shared/services/data.service";
import { LoaderService } from "src/app/shared/services/loader/loader.service";
import { ResponseData } from "src/app/shared/services/teacher.interface";

@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.scss"],
})
export class CategoryComponent implements OnInit {
  constructor(
    private router: Router,
    private loader: LoaderService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.checkTeacherStatus();
  }

  checkTeacherStatus() {
    this.loader.display(true);
    this.dataService.getTeacherGroupStatus().subscribe({
      next: (res: ResponseData<TeacherStatus>) => {
        //if the game started and live, then res.data will have an object
        //otherwise the we get res.data as a empty object
        if (res.data?.start_time && res.data?.status != 101) {
          let endTime = Math.floor(Number(res.data.end_time));
          sessionStorage.setItem("end_time", endTime.toString());
          sessionStorage.setItem("GCTeamId", res.data.id);
          this.router.navigateByUrl("/leaderboard");
          this.loader.display(false);
        } else if (res.data?.status == 101) {
          sessionStorage.setItem("GCTeamId", res.data.id);
          this.router.navigateByUrl("/join-team");
          this.loader.display(false);
        }
        this.loader.display(false);
      },
      error: (err) => {
        console.log(err);
        this.loader.display(false);
      },
    });
  }

  onGameSettingsChange(id: string) {
    // console.log(id);
    this.router.navigateByUrl("/instructions");
  }
}

interface TeacherStatus {
  id: string;
  group_code: string;
  start_time: number;
  end_time: number;
  status: number;
}
